/*
  Разбор таблицы жильцов до записи - кто окажется в листе (шаг 3, 30.09.2026).

  Вынесен из `ResidentsUpload` 06.10.2026, когда шаг стал принимать скан общей
  кнопкой и упёрся в потолок компонента. Показ разбора - самостоятельная часть:
  получает план пропсом и сам ничего не грузит.
*/

import { accountsDative, rows as rowsCount } from '../api/format.js'

const SHOWN_ROWS = 20
/* Полное число стоит рядом: список в тысячу строк не читается, а двадцати
   хватает, чтобы понять, что не так с файлом. */

const SHOWN_BOOKS = 10

function People({ book }) {
  return (
    <p className="onec__summary">
      <b>
        {book.account_number}, {book.address}
      </b>
      : {book.people.join(', ')}.
      {book.replaced > 0 ? (
        <span className="muted"> Прежняя загрузка по этому счёту заменяется ({book.replaced}).</span>
      ) : null}
    </p>
  )
}

export default function ResidentsPlan({ plan }) {
  return (
    <div className="onec__summary">
      <p>
        Строк в файле: <b>{rowsCount(plan.total)}</b>. Жильцов будет записано:{' '}
        <b>{plan.written}</b> по <b>{accountsDative(plan.accounts)}</b>.
      </p>
      {plan.books.slice(0, SHOWN_BOOKS).map((book) => (
        <People key={book.account_id} book={book} />
      ))}
      {plan.books.length > SHOWN_BOOKS ? (
        <p className="muted">
          Показаны первые {SHOWN_BOOKS} счетов из {plan.books.length}.
        </p>
      ) : null}
      {plan.issues.length > 0 ? (
        <>
          <p className="onec__skipped">Требуют вашего внимания: {rowsCount(plan.issues.length)}.</p>
          {plan.issues.slice(0, SHOWN_ROWS).map((issue) => (
            <p key={`${issue.row_number}-${issue.account_number ?? ''}`} className="onec__skipped">
              Строка {issue.row_number}: {issue.explanation}
            </p>
          ))}
        </>
      ) : null}
    </div>
  )
}
